module.exports = __webpack_public_path__ + "static/media/message-close.1d7497fb.svg";